import m from "../../../../geodata/es2015/region/world/middleEastHigh";
window.am4geodata_region_world_middleEastHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/world/middleEastHigh.js
// module id = null
// module chunks = 